import * as React from "react";
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Routes, Route } from "react-router-dom";
import { Theme } from "@mui/styles";
import AppView from "~common/components/app-view/index";
import QueryList from "~common/components/query-fulfillment/query-list-fc";
import * as request from "superagent";
import URLManager from "~common/lib/url-manager";
import Require from "~common/components/require";

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  status: "loading" | "ready";
};

class UserGroupFeatureReport extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: "ready",
    };
  }

 componentDidMount() {}

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) {}

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;

    var criteriaSelector = {
      formType: "userGroupFeatureReportCriteria",
      form: "userGroupFeatureCriteria",
      modules: "users",
    };
    var resultsSelector = {
      formType: "userGroupFeatureReportResults",
      form: "userGroupFeatureResults",
      modules: "users",
    };

    return (
      <div className={classes.container}>
        <AppView history={this.props.history}>
          <Require classes={{}} requireOneOfFeatures={["user_group_feature_report"]}>
            <QueryList
              suppressCriteriaView={false}
              criteriaFormSelector={criteriaSelector}
              resultsFormSelector={resultsSelector}
              queryUrl="/api/users/report/features/query"
              autoQuery={true}
              excludeFromClear={[]}
              // onCriteriaFormSelection={this.handleCriteriaFormSelection}
              supressSectionStatusIcon
              // onRowClick={this.handleRowClick}
              // actionsForItemRow={this.handleActionsForItemRow}
              alwaysExecuteOnSubmit={true}
              noResultsText="No Results Found"
              reserveRowActionSpace={true}
              pruneCriteriaForm={true}
              submitButtonText={"Search"}
            />
          </Require>
        </AppView>
      </div>
    );
  }
}

export default withStyles(styles)(UserGroupFeatureReport);
